module.exports = __webpack_public_path__ + "assets/images/6-1.jpg";